module.exports = __webpack_public_path__ + "img/delivery.70e746bc.png";